import { z } from "zod/mini"

import type { BooleanLegacy } from "./boolean"
import { BooleanLegacySchema } from "./boolean"
import type { EmbedLegacy } from "./embed"
import { EmbedLegacyLooseSchema } from "./embed"
import type { EmptyLegacy } from "./empty"
import { EmptyLegacySchema } from "./empty"
import type { StringLegacy } from "./field"
import { StringLegacySchema } from "./field"
import type { GeoPointLegacy } from "./geopoint"
import { GeoPointLegacySchema } from "./geopoint"
import type { ImageLegacy } from "./image"
import { ImageLegacySchema } from "./image"
import type { IntegrationFieldLegacy } from "./integrationField"
import { IntegrationFieldLegacySchema } from "./integrationField"
import type { LinkLegacy } from "./link"
import { LinkLegacySchema } from "./link"
import type { RepeatableLegacy } from "./repeatable"
import { RepeatableLegacySchema } from "./repeatable"
import type { RichTextLegacy } from "./richText"
import { RichTextLegacySchema } from "./richText"
import type { SeparatorLegacy } from "./separator"
import { SeparatorLegacySchema } from "./separator"
import type { TableLegacy } from "./table"
import { TableLegacySchema } from "./table"

export const NestableLegacySchema: z.ZodMiniType<NestableLegacy> = z.union([
	EmptyLegacySchema,
	BooleanLegacySchema,
	EmbedLegacyLooseSchema,
	StringLegacySchema,
	GeoPointLegacySchema,
	ImageLegacySchema,
	IntegrationFieldLegacySchema,
	LinkLegacySchema,
	RepeatableLegacySchema,
	RichTextLegacySchema,
	SeparatorLegacySchema,
	TableLegacySchema,
])

export type NestableLegacy =
	| EmptyLegacy
	| BooleanLegacy
	| EmbedLegacy
	| StringLegacy
	| GeoPointLegacy
	| ImageLegacy
	| IntegrationFieldLegacy
	| LinkLegacy
	| RepeatableLegacy
	| RichTextLegacy
	| SeparatorLegacy
	| TableLegacy
